import { Flex } from 'components/layout';
import { Typography } from 'components/typography';
import { cn } from 'utils/shadcn';

import { TQLLogo } from './TQLLogo';

/** TQL brand blue from official wordmark (portal `tql-logo.svg`). */
export const TQL_BRAND_BLUE = '#0093d0';

type TQLTruPayLogoProps = {
  className?: string;
  compact?: boolean;
};

/** TQL logo + TruPay product label for Quick Quote cards. */
export function TQLTruPayLogo({ className, compact }: TQLTruPayLogoProps) {
  return (
    <Flex align='center' gap='sm' className={cn(className)}>
      <TQLLogo compact={compact} />
      <Flex
        direction='col'
        className='leading-none border-l border-neutral-200 pl-2'
      >
        <Typography
          variant={compact ? 'body-xs' : 'body-sm'}
          weight='semibold'
          className='text-neutral-900'
        >
          TruPay
        </Typography>
        {!compact && (
          <Typography variant='body-xs' className='text-neutral-500'>
            All-in linehaul
          </Typography>
        )}
      </Flex>
    </Flex>
  );
}
